import { functionnal } from "vincent-utils";
import { z } from "zod/v4";
import { DateTime } from "luxon";
const not = functionnal.not;
const caseIsFromDay = function (dayInFrenchLowerCase) {
    return function (rdvCase) {
        return (DateTime.fromJSDate(rdvCase.date).setLocale("fr").toFormat("EEEE") ===
            dayInFrenchLowerCase);
    };
};
const isBeforeTime = function (hmObject) {
    return function (rdv) {
        return (rdv.hour * 60 + rdv.minute + rdv.duration <=
            hmObject.hour * 60 + hmObject.minute);
    };
};
const isAfterOrEqualTime = function (hmObject) {
    return function (rdv) {
        return rdv.hour * 60 + rdv.minute >= hmObject.hour * 60 + hmObject.minute;
    };
};
const hmObjSchema = z.object({
    heure: z.number().int(),
    minute: z.number().int(),
});
const beforeSchema = z.object({
    mode: z.literal("avant"),
    first: hmObjSchema,
});
const afterSchema = z.object({
    mode: z.literal("après"),
    first: hmObjSchema,
});
const betweenSchema = z.object({
    mode: z.literal("entre"),
    first: hmObjSchema,
    second: hmObjSchema,
});
const noConstraintSchema = z.object({
    mode: z.literal("toute la journée"),
});
const closedConstraintSchema = z.object({
    mode: z.literal("unavailable"),
});
export const timeConstraintSchema = z.union([
    beforeSchema,
    afterSchema,
    betweenSchema,
    noConstraintSchema,
    closedConstraintSchema,
]);
const buildCandidatesCasesFilters = function (obj) {
    let predicateArray = [];
    Object.keys(obj).forEach((jour) => {
        const jourCopy = jour;
        const actualConstraint = obj[jourCopy];
        if (actualConstraint.mode === "toute la journée") {
            return;
        }
        if (actualConstraint.mode === "unavailable") {
            predicateArray.push(caseIsFromDay(jourCopy));
            return;
        }
        if (actualConstraint.mode === "avant") {
            predicateArray.push(functionnal.multiPredicatesToUniquePredicate([caseIsFromDay(jourCopy), not(isBeforeTime(actualConstraint.first))]));
        }
        if (actualConstraint.mode === "après") {
            predicateArray.push(functionnal.multiPredicatesToUniquePredicate([
                caseIsFromDay(jourCopy),
                not(isAfterOrEqualTime(actualConstraint.first)),
            ]));
        }
        if (actualConstraint.mode === "entre") {
            predicateArray.push(functionnal.multiPredicatesToUniquePredicate([
                caseIsFromDay(jourCopy),
                not(isAfterOrEqualTime(actualConstraint.first)),
            ]));
            predicateArray.push(functionnal.multiPredicatesToUniquePredicate([
                caseIsFromDay(jourCopy),
                not(isBeforeTime(actualConstraint.second)),
            ]));
        }
    });
    return (candidates) => {
        return candidates
            .map((dayCases) => dayCases.filter((candidate) => !predicateArray.some((pred) => pred(candidate))))
            .filter((arr) => arr.length > 0)
            .flat();
    };
};
export { buildCandidatesCasesFilters };
//# sourceMappingURL=filterCandidatesByContrainte.js.map